export default "__VITE_ASSET__458a0939__"